import { FiArrowLeft, FiShield } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Policies = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/signin"
          className="inline-flex items-center text-sm font-medium text-orange-600 hover:text-orange-500 mb-6"
        >
          <FiArrowLeft className="mr-2 h-4 w-4" />
          Back to Sign In
        </Link>

        <div className="bg-white rounded-2xl p-8 card-shadow border border-gray-100">
          <h1 className="text-3xl font-bold text-gray-900">Policies</h1>
          <p className="mt-2 text-sm text-gray-500">Terms of use, privacy, and operational rules for UsedAdda Agent Portal</p>
          <p className="mt-1 text-xs text-gray-500">Last updated: 14 April 2026</p>

          <div className="mt-8 space-y-6 text-sm text-gray-700 leading-7">
            <section>
              <h2 className="text-lg font-semibold text-gray-900 inline-flex items-center">
                <FiShield className="mr-2 h-5 w-5 text-orange-500" />
                1. Acceptance and Scope
              </h2>
              <p className="mt-2">
                These policies govern access and use of the UsedAdda Agent Portal operated under MK WHEELS LLP.
                By signing in, creating listings, managing sellers, or handling inquiries, you agree to these terms.
                These terms apply to all agent users, support staff, and any person using an authorized agent account.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">2. Authorized Use of Agent Portal</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>Portal access is strictly for used-vehicle business workflows connected to UsedAdda.</li>
                <li>Agents must use the platform only for lawful business activities and approved operational purposes.</li>
                <li>Each action performed from an agent account is treated as authorized by that account owner.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">3. Account Responsibility and Security</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>Login credentials must be protected and not shared with unauthorized persons.</li>
                <li>Agents are responsible for maintaining accurate profile and business information.</li>
                <li>Any suspicious activity, compromise, or misuse must be reported immediately to support.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">4. Listings, Enquiries, and Data Integrity</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>Vehicle information, pricing, ownership, and documents must be true, verifiable, and current.</li>
                <li>Misleading claims, manipulated images, fake inventory, and unauthorized listings are prohibited.</li>
                <li>Duplicate, fraudulent, abusive, or policy-violating listings may be edited, blocked, or removed.</li>
                <li>Inquiry data and lead details must be handled professionally and only for valid business follow-up.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">5. Prohibited Conduct</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>Attempting unauthorized access, scraping, reverse engineering, or security bypass.</li>
                <li>Uploading harmful code, spam, illegal content, or content violating third-party rights.</li>
                <li>Using the portal in a way that harms platform stability, user trust, or compliance obligations.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">6. Privacy, Storage, and Communications</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>Personal and business data is processed for platform operations, customer support, and compliance.</li>
                <li>Operational records (such as listings, edits, and inquiry actions) may be retained for audit and dispute handling.</li>
                <li>Platform notices and policy updates may be delivered via portal notifications, email, or registered contact channels.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">7. Intellectual Property and Third-Party Services</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>UsedAdda platform content, branding, and software are protected and remain the property of MK WHEELS LLP or its licensors.</li>
                <li>Third-party links or services may have their own terms and privacy rules; those apply separately.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">8. Suspension, Termination, and Enforcement</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>Accounts may be temporarily or permanently restricted for policy violations, fraud risk, or legal requirements.</li>
                <li>Serious violations may trigger legal action and reporting to relevant authorities where required.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">9. Disclaimer and Limitation of Liability</h2>
              <p className="mt-2">
                The portal is provided on an as-available basis. While reasonable efforts are made for reliability,
                uninterrupted access and error-free operation cannot be guaranteed. To the maximum extent permitted by law,
                MK WHEELS LLP is not liable for indirect or consequential losses arising from portal use, outages,
                third-party failures, or unauthorized account activity caused by poor credential security.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">10. Governing Law and Jurisdiction</h2>
              <p className="mt-2">
                These policies are governed by the laws of India. Disputes related to these terms or portal use
                will be subject to competent courts in Eluru, Andhra Pradesh, unless otherwise required by applicable law.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">11. Business and Contact</h2>
              <div className="mt-2 rounded-xl bg-orange-50 border border-orange-100 p-4 space-y-1 text-gray-800">
                <p><span className="font-semibold">Business Name:</span> MK WHEELS LLP</p>
                <p><span className="font-semibold">Product:</span> UsedAdda</p>
                <p><span className="font-semibold">Address:</span> 12-71/7342, NEHRU NAGAR, Near BIT-1, Eluru, Andhra Pradesh, 534001</p>
                <p><span className="font-semibold">Email:</span> support@usedadda.com</p>
              </div>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">12. Policy Updates</h2>
              <p className="mt-2">
                We may revise these policies from time to time to reflect operational, legal, or security requirements.
                Continued use of the portal after updates means acceptance of the revised terms.
              </p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-100 flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="font-medium text-orange-600 hover:text-orange-500">About Us</Link>
            <Link to="/terms-and-conditions" className="font-medium text-orange-600 hover:text-orange-500">Terms & Conditions</Link>
            <Link to="/refund-policy" className="font-medium text-orange-600 hover:text-orange-500">Refund Policy</Link>
            <Link to="/contact" className="font-medium text-orange-600 hover:text-orange-500">Contact Details</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policies;
